/* eslint-disable linebreak-style */
import { composeWhereClause } from '../../modules/data';
import { rdsSelect, rdsTabulate } from '../../modules/rds';
import { stateFIPS } from '../../modules/states';

const povertyIncome = {
  'Family of 3': 20578,
  'Family of 2': 17662,
};

export default povertyIncome;

export function getMedianHouseholdIncome(stateCode, countyCode) {
  let dataProduct = 'acs_sams_state_wide';
  let where = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
  if (countyCode) {
    dataProduct = 'acs_sams_county_wide';
    where += ` AND county_fips=${countyCode} AND (county_suppressed=0 OR county_suppressed=NULL)`;
  }
  return rdsSelect('3rdparty', dataProduct, {
    cols: 'inc_hh,inc_fam_married,inc_fam_nospouse',
    where,
    format: 'amcharts',
    inject: false,
  }, true);
}

export function getRatesByState(stateCode, countyCode, filters) {
  let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
  whereClause += composeWhereClause(filters);

  if (countyCode) {
    whereClause += ` AND county_fips=${countyCode}`;
  }

  return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
    dims: 'state',
    measure: 'average_rate:AVG(rate)',
    where: whereClause,
    format: 'amcharts',
    inject: true,
    weights: 'cnt',
  }, true);
}
